const $ = window.jQuery

window.hubspotTrack = (formId, data) => {
  $.post('/umbraco/surface/Hubspot/SubmitForm?formGuid=' + formId, data)
  if (window.analytics) {
    switch (formId) {
      case 'b60b6734-5d5d-4ed3-9f85-dd989aabe2c8':
        window.analytics.track('HQ WWW Download tech specs (eng)')
        break
      case 'd9bb6915-1e5a-4341-8854-3abbc1b41984':
        window.analytics.track('UR+ partner website gate')
        break
    }
  }
}
